import tippy from 'tippy.js'

const PopUp = (function () {
  const selector = '.js-pop-up'
  const elements = document.querySelectorAll(selector)

  const initPopUps = () => {
    elements.forEach((triggerEl) => {
      const popUpSelector = triggerEl.dataset.target
      const popUpEl = document.querySelector(popUpSelector)

      if (popUpEl) {
        const popUp = tippy(triggerEl, {
          allowHTML: true,
          // appendTo parent required for a11y features
          appendTo: triggerEl.parentNode,
          content: popUpEl,
          interactive: true,
          animation: 'shift-away',
          trigger: 'click',
          offset: 0,
          arrow: false,
          popperOptions: {
            placement: 'top',
            modifiers: [
              {
                name: 'flip',
                options: {
                  fallbackPlacements: ['bottom'],
                },
              },
              {
                name: 'preventOverflow',
                options: {
                  altAxis: true,
                  tether: true,
                },
              },
            ],
          },
          // Move keyboard focus to pop-up on open
          onShown(instance) {
            instance.popper.focus()
          },
        })

        const closeBtn = popUpEl.querySelector('.js-close-pop-up')
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            popUp.hide()
          })
        }
      }
    })
  }

  return {
    init: () => {
      initPopUps()
    },
  }
})()

export default PopUp
